// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4100fb50","453":"8461157b"}[chunkId] + ".chunk.js";
};